import { render } from "./CreateEditInvigilator.vue?vue&type=template&id=787d1bbc"
import script from "./CreateEditInvigilator.vue?vue&type=script&lang=js"
export * from "./CreateEditInvigilator.vue?vue&type=script&lang=js"
script.render = render

export default script